import VueCookies from 'vue-cookies';

export default class CookieManager {
	// Retrieve our environment variables
	constructor() {
		this.environment = process.env.VUE_APP_ENV;
		this.domain = process.env.VUE_APP_COOKIE_DOMAIN;
		this.secure = process.env.VUE_APP_COOKIE_SECURE === 'true';
	}

	// Set a cookie with our environment as prefix, our domain
	// and security level based on the environment
	set(key, value, duration = null) {
		if (!key || !value) {
			return;
		}

		VueCookies.set(`${this.environment}_${key}`, value, duration, null, `.${this.domain}`, this.secure);
	}

	// Delete a cookie with our environment as prefix
	remove(key) {
		VueCookies.remove(`${this.environment}_${key}`, null, `.${this.domain}`);
	}

	// Get a cookie with our environment as prefix
	get(key) {
		return VueCookies.get(`${this.environment}_${key}`);
	}

	// Verify if a cookie exist with our environment as prefix
	has(key) {
		return VueCookies.isKey(`${this.environment}_${key}`);
	}
}
